<template>
  <div v-if="show" class="tip-wrap" z-index="10000" @click.stop>
    <img class="pic" src="@/assets/images/system/points/toast.png" />
    <div class="count">+{{ count }}</div>
    <div class="blank"></div>
    <div class="action">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'PointsTip',
  props: {
    count: {
      type: Number,
      default: 1
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = false
    }, 2000)
  },
  methods: {}
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/setting.styl'
.tip-wrap
  min-width 326px
  height 60px
  padding: 0 15px
  display flex
  align-items: center
  justify-content: center
  position fixed
  bottom 200px
  left 50%
  transform: translateX(-50%)
  background: rgba(17,17,17,0.4)
  border-radius: 30px
  .pic
    width: 50px
    height: 48px
    margin-right: 10px
  .count
    font-size: 34px
    font-weight: bold
    color: #FFB300
  .blank
    width: 20px
  .action
    width: 100%
    font-size: 30px
    font-weight: 500
    text-align: right
    color: #fff
</style>
